import React, {useState} from 'react';
import {Modal, DropdownList, ButtonDropdownField} from '@forecast-it/design-system';
import {FormattedMessage, useIntl} from 'react-intl';
import {SEAT} from '../../../constants';

type ChooseSeatModalProps = {
	closeModal: () => void;
	callback: (arg: string) => void;
	collaboratorSeats: boolean;
	virtualSeats: boolean;
};

type SeatOption = {
	value: string;
	label: string;
};

const ChooseSeatModal = ({closeModal, callback, collaboratorSeats, virtualSeats}: ChooseSeatModalProps): React.JSX.Element => {
	const intl = useIntl();

	const seatOptions: SeatOption[] = [];
	seatOptions.push({
		value: SEAT.CORE,
		label: intl.formatMessage({id: 'settings_people.seat.core'}),
	});
	if (collaboratorSeats) {
		seatOptions.push({
			value: SEAT.COLLABORATOR,
			label: intl.formatMessage({id: 'settings_people.seat.collaborator'}),
		});
	}
	if (virtualSeats) {
		seatOptions.push({
			value: SEAT.VIRTUAL,
			label: intl.formatMessage({id: 'settings_people.seat.virtual'}),
		});
	}

	const [selectedSeatType, setSelectedSeatType] = useState<SeatOption>();
	const [errorMessage, setErrorMessage] = useState('');

	const showErrorMessage = () => {
		setErrorMessage(intl.formatMessage({id: 'settings_people.seat.please_select'}));
	};

	const chooseSeat = () => {
		if (selectedSeatType) {
			closeModal();
			callback(selectedSeatType.value);
		} else {
			showErrorMessage();
		}
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'integrations.hibob.choose_seat'} />
			</Modal.Title>
			<Modal.Content>
				<DropdownList>
					<DropdownList.Trigger>
						<ButtonDropdownField hasError={!!errorMessage} errorText={errorMessage}>
							{selectedSeatType ? selectedSeatType.label : '-----'}
						</ButtonDropdownField>
					</DropdownList.Trigger>
					<DropdownList.Content useTriggerWidth>
						{seatOptions.map(option => (
							<DropdownList.Item onClick={() => setSelectedSeatType(option)}>{option.label}</DropdownList.Item>
						))}
					</DropdownList.Content>
				</DropdownList>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={chooseSeat} dataCy={'modal-btn-choose-seat'} disabled={false}>
					<FormattedMessage id="common.next" />
				</Modal.PrimaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default ChooseSeatModal;
